<template>
  <div class="">
    <el-divider>{{ ts('Cancellation Policy')['Cancellation Policy'] }}</el-divider>
    <ul class="detail-option">
      <!-- 全额返还 -->
      <template v-if="detail.cancellationPolicyType == 'FULLYRE_FUNDABLE'">
        <li v-if="detail.beforeDays">{{ ts(`FULL REFUND on cancellation ${detail.beforeDays} days before check-in day`)[`FULL REFUND on cancellation ${detail.beforeDays} days before check-in day`] }}</li>
        <li v-else>{{ ts('FULL REFUND at any time of cancellation before check-in day')['FULL REFUND at any time of cancellation before check-in day'] }}</li>
      </template>
      <!-- 不退还 -->
      <li v-else-if="detail.cancellationPolicyType == 'NON_REFUNDABLE'">
        {{ ts(`NO REFUND on cancellation ${detail.beforeDays} days before check-in day`)[`NO REFUND on cancellation ${detail.beforeDays} days before check-in day`] }}</li>
      <!-- 部分退还 -->
      <template v-else-if="detail.cancellationPolicyType == 'MANUAL'">
        <!-- 百分比 -->
        <li v-if="detail.manualPolicyType == 'PERCENTAGE'">{{ ts(`${detail.chargeValue}% REFUND on cancellation ${detail.beforeDays} days before check-in day`)[`${detail.chargeValue}% REFUND on cancellation ${detail.beforeDays} days before check-in day`] }}</li>
        <!-- 固定价值 -->
        <li v-if="detail.manualPolicyType == 'FLAT'">{{ ts(`JPY ${detail.chargeValue} REFUND on cancellation ${detail.beforeDays} days before check-in day`)[`JPY ${detail.chargeValue} REFUND on cancellation ${detail.beforeDays} days before check-in day`] }}</li>
      </template>
    </ul>
  </div>
</template>

<script>
import { LanguagePackage } from '@/mixins/LanguagePackage'

export default {
  name: 'CancellationPolicy',
  props: ['detail'],
  mixins: [LanguagePackage],
  data() {
    return {}
  },
  components: {},
}
</script>

<style scoped lang="sass"></style>
